import { render, staticRenderFns } from "./FeedProductGeneralTab.vue?vue&type=template&id=de099162&"
import script from "./FeedProductGeneralTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductGeneralTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports